import React from "react";
import { NextSeo, ArticleJsonLd } from "next-seo";

export default function BlogPostSEO({ blogPost }) {
    const title = `${blogPost.title} by ${blogPost.author_name}`;
    const description = blogPost.title;
    // (bug) include it two times because if we don't the default image on <DefaultSeo/> will be shown
    const images = [
        { url: blogPost.header_image_file },
        { url: blogPost.header_image_file },
    ];
    const articleImages = [blogPost.header_image_file];

    return (
        <>
            <NextSeo
                title={title}
                description={description}
                canonical={`https://www.inuua.net/blog/posts/${blogPost.slug}`}
                openGraph={{
                    type: "website",
                    locale: "en_GB",
                    url: `https://www.inuua.net/blog/posts/${blogPost.slug}`,
                    site_name: "Inuua Tujenge",
                    title: title,
                    description: description,
                    images: images,
                }}
            />
            <ArticleJsonLd
                url={`https://www.inuua.net/blog/posts/${blogPost.slug}`}
                title={title}
                images={articleImages}
                datePublished={blogPost.first_published_at}
                dateModified={blogPost.last_published_at}
                authorName={[`${blogPost.author_name}`]}
                publisherName="Inuua Tujenge"
                publisherLogo="https://www.inuua.net/icons/icon-512x512.png"
                description={description}
            />
        </>
    );
}
